var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"dense":_vm.$vuetify.breakpoint.smAndDown,"justify":"center","align":"center"}},[_c('v-col',[_c('center',[_c('div',{staticClass:"text-h5"},[_vm._v(" 404 Not Found ")]),_c('app-btn',{staticClass:"mt-5",attrs:{"to":"/"}},[_vm._v(" Return to the dashboard ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }